import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DfSpinnerButtonModule } from './spinner-button';
import { DfSpinnerModule } from './spinner';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DfSpinnerButtonModule,
    DfSpinnerModule,
  ],
  exports: [DfSpinnerButtonModule, DfSpinnerModule],
  declarations: [],
  providers: [],
})
export class DfPlaceholdersModule {}
